import React from 'react';
import { Section } from './ui/Section';
export function FAQ() {
  const faqs = [{
    q: '¿Cómo lo recibo?',
    a: 'Email instantáneo con enlace de descarga. Acceso 24/7.'
  }, {
    q: '¿Es seguro?',
    a: 'Sí. Shopify Payments con cifrado SSL 256 bits.'
  }, {
    q: '¿Un solo pago?',
    a: 'Sí. 13,99€ o 19,99€. Sin suscripciones ni sorpresas.'
  }, {
    q: '¿Sirve para principiantes?',
    a: 'Sí. Diseñado desde cero para recién graduados.'
  }, {
    q: '¿Qué incluye cada pack?',
    a: 'Base: 6 tomos + 3 bonos. Premium: + Pack Legal (79€).'
  }, {
    q: '¿Cumple normativa española?',
    a: 'Sí. RGPD, LOPDGDD, Ley 41/2002, Ley 37/1992 IVA.'
  }];
  return <Section data-id="element-63">
      <h2 className="font-display text-2xl md:text-3xl font-bold text-center mb-6 text-brand-primary" data-id="element-64">
        ❓ PREGUNTAS FRECUENTES
      </h2>

      <div className="max-w-3xl mx-auto grid md:grid-cols-2 gap-4" data-id="element-65">
        {faqs.map((faq, i) => <div key={i} className="bg-white border border-brand-border rounded-lg p-4 shadow-sm" data-id="element-66">
            <h3 className="font-heading font-bold text-sm text-brand-primary mb-2" data-id="element-67">
              {faq.q}
            </h3>
            <p className="font-body text-brand-text text-xs" data-id="element-68">{faq.a}</p>
          </div>)}
      </div>
    </Section>;
}